import React, { Component } from 'react';
import './footer.css';


function Footer (props){
  return(
<div className="footer">  <div className="text-social-area">

<span id="siteseal"><script async type="text/javascript" src="https://seal.godaddy.com/getSeal?sealID=3xl37izkrjTnerNFozBqPEK6rLxxmShaQoha8mTQ61JpgrpGsHeiE4hfQ0Pc"></script></span>
    <p className="copyright">Copyright 2017 Gift Cards Fast</p>
    <div className="facebook"></div>
    <div className="twitter"></div>
<script type="text/javascript" src="https://cdn.ywxi.net/js/1.js" async></script>
  </div></div>
  )

}






export default Footer;



// WEBPACK FOOTER //
// ./src/footer.js